export enum PlanTypesString {
  COBRA = 'cobra',
  DIRECTBILL = 'directBill',
  CUSTOM = 'custom',
  HSA = 'HSA',
  FSA = 'FSA',
  HRA = 'HRA',
  QTE = 'QTE',
}
